import { cn } from "../../../../utils/cn.ts";
import { FontStyles } from "../../../../utils/font-styles.ts";
import { focusStyles } from "../../../../utils/focus-styles.ts";

export interface GalleryActionButtonProps {
  icon: string;
  label: string;
  ariaLabel: string;
  ariaPressed?: boolean;
  onClick?: () => void;
  isSolidIcon?: boolean;
  loading?: boolean;
}

export const GalleryActionButton = ({
  icon,
  label,
  ariaLabel,
  ariaPressed,
  onClick,
  isSolidIcon = false,
  loading = false,
}: GalleryActionButtonProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      aria-pressed={ariaPressed}
      disabled={loading}
      className={cn(
        FontStyles["body-md"],
        "shadow-loch-800 ",
        focusStyles,
        "lg:active:!bg-loch-100",
        "lg:text-body-l flex gap-1.5 md:gap-2 lg:py-4.5 lg:px-1.5 lg:hover:bg-loch-50 items-center cursor-pointer !leading-none",
      )}
    >
      <span className={cn("flex gap-1.5 md:gap-2 items-center", loading && "animate-pulse")}>
        <i
          className={cn(`fa-${icon}`, isSolidIcon ? "fa-solid" : "fa-regular", "fa-sharp text-loch")}
          aria-hidden="true"
        />
        <span className={`font-medium text-slate`}>{label}</span>
      </span>
    </button>
  );
};
